/* global wasm_bindgen */

import { setPositions, setUnchangedPositions, decodeChirality, alignFlip } from '@moleculeone/draw';
import { calculateSeededPositions } from '../../../../utils/mol';

export const getMolWithPositions = (smiles, mol) => {
  let updatedMol = setPositions(
    mol,
    calculateSeededPositions({
      mol,
      seedId: smiles,
    })
  );
  updatedMol = decodeChirality(updatedMol);
  return updatedMol;
};

export const alignMol = (productMol, substrateMol, mapToProduct, substrateToMap) => {
  if (!productMol) {
    return substrateMol;
  }

  const alignMap = {};

  for (const [substrateAtomId, mapId] of Object.entries(substrateToMap)) {
    const productAtomId = mapToProduct[mapId];
    alignMap[substrateAtomId] = productMol.positions[productAtomId];
  }

  return setUnchangedPositions(substrateMol, alignFlip(substrateMol.positions, alignMap));
};
